import Vue from 'vue';
import Axios from 'axios';
import VueCookie from 'vue-cookie';
import VueI18n from 'vue-i18n';
import VueNativeSock from './vue-native-websocket/Main';
import router from './router/index';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import store from './store/store';
import i18n from './plugins/i18n';
import { serverAdress } from './properties/server';
import resize from "vue-element-resize-detector";

Vue.prototype.$http = Axios;


Vue.use(VueI18n);
Vue.use(VueCookie);
Vue.use(resize);


Vue.use(VueNativeSock, serverAdress, {
  store,
  format: 'json',
  connectManually: true,
});

Vue.config.productionTip = false;

i18n.locale = navigator.language;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  i18n,
  template: '<App/>',
});
